// /start-a-circle — public ad-entry landing for the "start-circle" journey.

import { useEffect } from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { EntryJourneyLanding } from '@/components/entry-journeys';
import { useEntryJourneyCopy } from '@/components/entry-journeys/journey-copy';
import { writeEntryJourney } from '@/lib/entry-journey';
import { refSearchParam, storeSignupRef } from '@/lib/signup-ref-cookie';

export const Route = createFileRoute('/_public/start-a-circle')({
  // Signed-in visitors can act on the ad's promise directly. A signed-in
  // visitor who never finished onboarding re-enters the JOURNEY onboarding
  // (the layout gate exempts entry paths so the ad's intent isn't stripped
  // by a bounce to the organic profile step).
  beforeLoad: ({ context }) => {
    if (context.session !== null) {
      if (context.member !== null && context.member.onboardingCompletedAt === null) {
        writeEntryJourney('start-circle');
        throw redirect({ to: '/onboarding/j/about' });
      }
      throw redirect({ to: '/circles/new' });
    }
  },
  validateSearch: (search: Record<string, unknown>) => refSearchParam(search),
  component: StartCircleEntryPage,
});

function StartCircleEntryPage() {
  const { ref } = Route.useSearch();
  // Cookie the campaign ref on arrival (signed-out only — beforeLoad already
  // bounced signed-in visitors) so it survives the signup + OAuth round-trip;
  // /auth/finishing claims it. The URL stays clean from here on.
  useEffect(() => {
    if (ref !== undefined) storeSignupRef(ref);
  }, [ref]);
  return (
    <EntryJourneyLanding
      journey="start-circle"
      {...useEntryJourneyCopy('start-circle')}
    />
  );
}
